import { useState } from "react";
import { useAtom } from "lib/global-context";
import { cn } from "lib/utils";
import { ageAtom } from "lib/atoms";
import { Input } from "components/ui/input";
import { debounce } from "lodash";
import { isValidAge } from "lib/validation";
import styles from "./input-age.module.css";

interface InputAgeProps {
  config: {
    min: number;
    max: number;
    displayConfiguration: {
      inputType: string;
      title: string;
      placeholder?: string;
      name: string;
    };
  };
}

const InputAge = ({ config }: InputAgeProps) => {
  const { min, max, displayConfiguration } = config;
  const { inputType, title, name, placeholder } = displayConfiguration;

  const [age, setAge] = useAtom(ageAtom);
  const [tempValue, setTempValue] = useState<string>(
    age !== null ? age.toString() : "",
  );
  const [error, setError] = useState<string | null>(null);

  const validateAge = debounce((value: string) => {
    const ageValue = value === "" ? null : Number(value);
    setAge(ageValue);

    if (!isValidAge(ageValue, min, max)) {
      setError(`Input an age between ${min} - ${max}`);
    } else {
      setError(null);
    }
  }, 300);

  const handleAgeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (/^[0-9]*$/.test(value)) {
      setTempValue(value);
      validateAge(value);
    }
  };

  return (
    <div className={styles.container}>
      <label
        htmlFor={name}
        className={cn(styles.label, error && styles.labelError)}
      >
        {error || title}
      </label>
      <Input
        id={name}
        type={inputType}
        placeholder={placeholder}
        value={tempValue}
        onChange={handleAgeChange}
        className={cn(styles.input, error && styles.inputError)}
        required
      />
    </div>
  );
};

export default InputAge;
